const OPTICAL_SIZE_BASE_URL = 'https://fonts.gstatic.com/s/i/short-term/release/materialsymbols';

/**
 * Retourne la taille optique Material Symbols (20, 24, 40, 48) la plus proche
 * de la taille d'affichage en pixels.
 */
const getOpticalSize = (displayPx) => {
  if (!displayPx || displayPx <= 0) return 24;
  if (displayPx <= 22) return 20;
  if (displayPx <= 32) return 24;
  if (displayPx <= 44) return 40;
  return 48;
};

const buildIconUrl = (style, icon, variant, opticalSize) =>
  `${OPTICAL_SIZE_BASE_URL}${style}/${icon}/${variant}/${opticalSize}px.svg`;

class ThemeIcon extends HTMLElement {
  connectedCallback() {
    const { iconStyle, iconName, iconVariant } = this.dataset;
    if (!iconStyle || !iconName || !iconVariant) return;

    // Une seule ressource vectorielle se redimensionne proprement en CSS.
    // Cela évite un getComputedStyle et un ResizeObserver pour chaque icône.
    const url = buildIconUrl(iconStyle, iconName, iconVariant, 24);
    this.style.setProperty('--icon-url', `url('${url}')`);
  }
}

if (!customElements.get('theme-icon')) {
  customElements.define('theme-icon', ThemeIcon);
}
